import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useMutation, useQuery } from "react-query";
import ReactQuill from "react-quill";
import 'react-quill/dist/quill.snow.css';
import { addCopyRightPolicy, getCopyRightPolicy } from "../../../api";
import { snackActions } from "../../../helpers/SnackUtilsConfigurator";


const Copyright = () => {
  const [bodyText, setBodyText] = useState("");
  const {
    data: copyrightPolicyData,
  } = useQuery("copyright", getCopyRightPolicy);

  const {
    mutateAsync: addCopyRightPolicyAPI,
    isLoading: isAddingCopyRightPrivacy,
  } = useMutation("add-copyright", addCopyRightPolicy);

  useEffect(() => {
    if (copyrightPolicyData) {
      setBodyText(copyrightPolicyData.data?.description);
    }
  }, [copyrightPolicyData]);

  const handleSubmit = async () => {
    let bodyParams = {
      description: bodyText
    }
    let response = await addCopyRightPolicyAPI(bodyParams);
    if (response?.status) {
      snackActions.success(response?.message ?? "Privacy & Policy Updated Successfully!");
    } else {
      snackActions.error(response?.message ?? "Something went wrong!");
    }

  }

  return (
    <div>
      <div className="card mb-5 mb-xl-10 p-14">
        <ReactQuill
          theme="snow"
          placeholder="Write something..."
          modules={Copyright.modules}
          formats={Copyright.formats}
          style={{ height: "50vh" }}
          value={bodyText}
          onChange={(e) => setBodyText(e)}
        />
        <div className="d-flex justify-content-end">
          <Button variant="primary" style={{ width: "100px", marginTop: "50px" }} onClick={handleSubmit}  disabled={!bodyText || !bodyText?.replace(/<\/?[^>]+(>|$)/g, "")} color={!bodyText || !bodyText?.replace(/<\/?[^>]+(>|$)/g, "") ? "disabled" : "success"}>{isAddingCopyRightPrivacy ? "Loading." : "Submit"}</Button>{' '}
        </div>
      </div>
    </div>
  );
};

export default Copyright;


Copyright.modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link", "image"],
    [{ color: [] }],
  ],
};
Copyright.formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
];